import { useEffect } from "react";

const GoogleReviews = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div className="reviews-container">
      <div className="elfsight-app-d8e6b181-fe7f-4c3d-9732-9494dfc96e57" data-elfsight-app-lazy></div>
    </div>
  );
};

export default GoogleReviews;
